import type { Row } from '@tanstack/react-table';
import { useDataProvider } from '../DataProviderContext';

export const useIsRowClickable = () => {
  const { isRowClickable, onRowClick } = useDataProvider();

  return (row: Row<any, any>) => {
    // Row is expandable
    if (typeof row.getCanExpand === 'function' && row.getCanExpand()) {
      return true;
    }

    if (typeof isRowClickable === 'function') {
      return isRowClickable(row);
    }

    // Clickable, by default, if onRowClick is configured
    return typeof onRowClick === 'function';
  };
};
